import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HistoryModuleResponse, HistoryRuleResponse } from '../model/history-rule-response';
import { ReefRESTService } from '@reef/fwk-utils';
import { Router } from '@angular/router';
import { HistoryRuleRecord } from '../model/history-rule-record';
import { catchError, map } from 'rxjs/operators';
import { convertHistoryRuleResponseToHistoryRuleUIRecords } from '../util/history-rule-utils';

@Injectable({
  providedIn: 'root'
})
export class RuleHistoryService {
  constructor(
    private readonly reefRestService: ReefRESTService,
    private readonly router: Router
  ) {}

  getRuleHistory(criteria: HistorySearchCriteria, ruleId?: string): Observable<HistoryModuleResponse> {
    const moduleName = this.router.url.includes('/hotel') ? '/hotel' : '/journey';
    const payload: { criteria: HistorySearchCriteria; ruleId?: string } = { criteria };
    if (ruleId) {
      payload.ruleId = ruleId;
    }
    return this.reefRestService.post(`${moduleName}/rule/history/search`, payload);
  }

  getRuleHistoryForId(id: string): Observable<HistoryRuleRecord[]> {
    const moduleName = this.router.url.includes('/hotel') ? '/hotel' : '/journey';
    return this.reefRestService.get(`${moduleName}/rule/history/${id}`).pipe(
      map((response: HistoryRuleResponse) => convertHistoryRuleResponseToHistoryRuleUIRecords(response)),
      catchError(() => of([]))
    );
  }
}

export interface HistorySearchCriteria {
  owner?: string;
  timeRange?: {
    begin: string;
    end: string;
  };
  ruleId?: string;
  userID?: string;
}
